export const resolveFontSizePx = (
  minPx: number,
  maxPx: number,
  vw: number,
  minVw = 480,
  maxVw = 3840,
): number => {
  const clampedVw = Math.min(Math.max(vw, minVw), maxVw);
  const slope = (maxPx - minPx) / (maxVw - minVw);
  return minPx + slope * (clampedVw - minVw);
};
